// QueryFetcher centralises Explorer JSON requests. Consumers pass a plain
// params object (as produced by QueryParams.parse) and receive back an
// AbortableRequest.

import AbortableRequest from './abortable_request';
import * as QueryParams from './query_params';
import fetchWithOptions from 'util/fetch';

export function fetchJSON(path, params) {
  const url = `${QueryParams.BASE_JSON_PATH}/${path}${QueryParams.searchFor(params)}`;

  return new AbortableRequest(url, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
}

export function saveSearch(params, endpoint = 'outputs') {
  const path = `${QueryParams.BASE_PATH}/saved_searches`;
  const body = { ...QueryParams.buildPOSTParams(params), action_path: endpoint };

  return fetchWithOptions(path, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}
